import React from 'react';
import PropTypes from 'prop-types';

import styles from './BoostsHeader.module.scss';

const BoostsHeader = ({ title, subtitle }) => (
  <div className={styles.container}>
    <h1>{title}</h1>
    <p>{subtitle}</p>
  </div>
);

BoostsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default BoostsHeader;
